import { render, staticRenderFns } from "./UserC4View.vue?vue&type=template&id=59f438fa&"
import script from "./UserC4View.vue?vue&type=script&lang=js&"
export * from "./UserC4View.vue?vue&type=script&lang=js&"
import style0 from "./UserC4View.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports